import clsx from 'clsx';
import React, { FC } from 'react';
import { FaRegGrin, FaRegFrown } from 'react-icons/fa';
import { AreaRating } from '../../const/AreaRating';
import './RatingSummary.scss';

interface RatingSummaryType {
  active: boolean;
  type: AreaRating;
  count: number;
  onClick: (type: AreaRating) => void;
}
export const RatingSummary: FC<RatingSummaryType> = ({
  active,
  type,
  count,
  onClick,
}): JSX.Element => {
  const handleClick = () => onClick(type);

  return (
    <div
      className={clsx('rating-summary', type, { active })}
      onClick={handleClick}
    >
      <div className="indicator">
        {type === AreaRating.LIKE && <FaRegGrin size={40} />}
        {type === AreaRating.DISLIKE && <FaRegFrown size={40} />}
      </div>
      <div>
        <h4>{type}</h4>
        <div>Count: {count}</div>
      </div>
    </div>
  );
};
